/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.TransactionType_
///   This is an auto-generated enumeration of the SW_RealEstate.Core.TransactionType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum TransactionType_ {
   /// <summary>
   ///   Buyer (Buy)
   /// </summary>
   Buyer = 1,
   /// <summary>
   ///   Seller (Sell)
   /// </summary>
   Seller = 2,
   /// <summary>
   ///   Buyer/Seller (BuySell)
   /// </summary>
   BuyerSeller = 3,
   /// <summary>
   ///   Tenant (Tenant)
   /// </summary>
   Tenant = 4,
   /// <summary>
   ///   Landlord (LL)
   /// </summary>
   Landlord = 5,
   /// <summary>
   ///   Referral (Ref)
   /// </summary>
   Referral = 6
}

export const TransactionTypes: TransactionType[] = [
   {
      code: TransactionType_.Buyer,
      literal: 'Buyer',
      description: 'Buyer',
      shortDescription: 'Buy',
      listPriority: 0,

      propertyTypeCode: 1,

      typeName: "TransactionType"
   },
   {
      code: TransactionType_.Seller,
      literal: 'Seller',
      description: 'Seller',
      shortDescription: 'Sell',
      listPriority: 0,

      propertyTypeCode: 1,

      typeName: "TransactionType"
   },
   {
      code: TransactionType_.BuyerSeller,
      literal: 'BuyerSeller',
      description: 'Buyer/Seller',
      shortDescription: 'BuySell',
      listPriority: 0,

      propertyTypeCode: 1,

      typeName: "TransactionType"
   },
   {
      code: TransactionType_.Tenant,
      literal: 'Tenant',
      description: 'Tenant',
      shortDescription: 'Tenant',
      listPriority: 0,

      propertyTypeCode: 2,

      typeName: "TransactionType"
   },
   {
      code: TransactionType_.Landlord,
      literal: 'Landlord',
      description: 'Landlord',
      shortDescription: 'LL',
      listPriority: 0,

      propertyTypeCode: 2,

      typeName: "TransactionType"
   },
   {
      code: TransactionType_.Referral,
      literal: 'Referral',
      description: 'Referral',
      shortDescription: 'Ref',
      listPriority: 0,

      propertyTypeCode: 3,

      typeName: "TransactionType"
   }
]

export class TransactionType implements IDomainModel {
   code: TransactionType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   propertyTypeCode: number

   typeName: string

   static toDomainModel(code: TransactionType_): TransactionType {
      return TransactionTypes.find(d => d.code === code)
   }
}
